

































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "../ModalHeader.vue";
import { VueEditor } from "vue2-editor";
import { ProviderLogEntry } from "@/store/modules/types";
import { ProviderLogType } from "@/store/modules/enums";
import { randomId } from "@/utils";

@Component({
  components: {
    ModalHeader,
    VueEditor
  }
})
export default class ProviderLog extends Vue {
  @Prop() readonly provider: any;
  log: Array<any> = [];
  comment = "";
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }]
    ]
  };
  async getLog() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "providers/getLogById",
        this.provider.id
      );
      this.log = data.map(entry => {
        return {
          id: randomId(6),
          ...entry
        };
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveComment() {
    if (!this.comment) return;
    this.$store.commit("main/SET_LOADING", true);
    const entry: ProviderLogEntry = {
      providerId: this.provider.id,
      typeId: ProviderLogType.OFFICE_COMMENT,
      comment: this.comment
    };
    try {
      await this.$store.dispatch("providers/saveLog", entry);
      this.getLog();
      this.comment = "";
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  mounted() {
    this.getLog();
  }
}
